import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dps-detail',
  templateUrl: './dps-detail.component.html',
  styleUrls: ['./dps-detail.component.css']
})
export class DpsDetailComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
